import React, { useEffect, useState } from "react";
import { TableCell, IconButton } from "@mui/material";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

// Icons
import SettingsIcon from "@mui/icons-material/Settings";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import CloseIcon from "@mui/icons-material/Close";

// Components
import Box from "@/main/components/shared/box";
import KogAutoCompleteControlled from "@/main/components/shared/inputAutoComplete/autoCompleteControlled";
import SecondaryButton from "@/main/components/shared/button/secondaryButton";
import KogInputTextControlledNew from "@/main/components/shared/inputText/inputTextControlledNew";
import BoxGrid from "@/main/components/shared/boxGrid/boxGrid";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import ResultNotFoundComponent from "@/main/components/shared/resultNotFound/resultNotFoundComponent";
import LoadingComponent from "@/main/components/shared/loading/loadingComponent";
import StatusImportHistoryComponent from "@/main/components/shared/status/statusImportHistoryComponent";
import KogKeyboardDatePickerContainer from "@/main/components/shared/datepicker/keyboardDatePickerContainer";
import ModalImportInvetory from "../importInventory/components/modalImportInventory";

// Styles
import * as S from "./styles";
import { KOGAreaButtons, SpinnerLoading } from "@/main/components/shared/styles";

// Redux
import { getCountriesUser, useCountryReducer } from "@/main/store/country";
import {
	getSupplierInventoryImportStatus,
	useSupplierInventoryImportStatusReducer,
} from "@/main/store/supplierInventoryImportStatus";
import { getSuppliers, resetReducerSuppliers, useSupplierReducer } from "@/main/store/supplier";

// Api's
import { supplierInventoryImportApi } from "@/main/api";

// Models
import { CompanyFilterRequest, LogErrorImportRequest, SupplierInventoryImportRequest } from "@/main/models/request";
import { KeyValue } from "@/main/models/common";
import { SupplierFilterRequest } from "@/main/models/request/supplierRequest";
import { SupplierInventoryImportDataResponse } from "@/main/models/response";

// Utils & Enums
import { PaginationEnum } from "@/main/services/enum/PaginationEnum";
import { HeadQuarterBranchFilterEnum } from "@/main/services/enum/HeadQuarterBranchFilterEnum";
import { StatusSupplierInventoryImportEnum } from "@/main/services/enum/StatusSupplierInventoryImportEnum";
import { downloadXML, downloadFile } from "@/main/services/utilsFile";
import {
	getDefaultMessageResultsFound,
	getTranslateByKey,
	removeEmptyValues,
	getDefaultOptionDrop,
	isValueQueryParams,
	isNullUndefined,
	mountReducerWithData,
} from "@/main/services/utils";
import { initalDateForm, onLoadDateRangePicker, validateFormDate } from "@/main/services/utilsDate";
import { formatDateToISOString } from "@/main/services/utilsDate";
import { StatusRegisterEnum } from "@/main/services/enum/StatusRegisterEnum";
import { ParameterTypeEnum } from "@/main/services/enum/ParameterTypeEnum";
import useFormQueryParams from "@/main/hooks/useformQueryParams";
import { withQueryparams } from "@/main/components/core/queryParams/queryparams";
import { useParameterByTypeScreenReducer } from "@/main/store/parameterByTypeScreen";
import { getCompanyType, useCompanyTypeReducer } from "@/main/store/companyType";
import { getCompany, resetReducerCompany, useCompanyReducer } from "@/main/store/company";
import { CompanyTypeEnum } from "@/main/services/enum/CompanyTypeEnum";
import KogInputAutoCompleteCheckControlled from "@/main/components/shared/inputAutoCompleteCheck/inputAutoCompleteCheckControlled";
import { InventoryFileTypeEnum } from "@/main/services/enum/InventoryFileTypeEnum";
import { getOptionsInventoryFileType } from "@/main/services/data/data";

export interface ISearchImportHistoryForm {
	tab: number;
	country: KeyValue | null;
	supplier: KeyValue | null;
	filename: string | null;
	tradeName: string | null;
	supplierInventoryImportStatus: KeyValue | null;
	inventoryFileType: KeyValue | null;
	startDate: Date;
	finalDate: Date;
	companyType: KeyValue | null;
	company: KeyValue[] | null;
}

interface IGridData {
	data: SupplierInventoryImportDataResponse[];
	totalItems: number;
	isLoading: boolean;
}

interface IPropsImportHistoryTab {
	showFilters: boolean;
	setShowFilters: (showFilters: boolean) => void;
	openModalImportInventory: boolean;
	closeModalImportInventory: () => void;
	filesModalImportInventory: File[];
	setFilesModalImportInventory: React.Dispatch<React.SetStateAction<File[]>>;
	setTabCurrent: (tab: number) => void;
	gridData: IGridData;
	setGridData: (form: IGridData) => void;
	hasShowMore: boolean;
	setHasShowMore: (hasShowMore: boolean) => void;
	searchGridHistory: (form: any) => void;
	gridDataEmpty: boolean;
	setGridDataEmpty: (empty: boolean) => void;
	exporting: boolean;
	setExporting: (value: boolean) => void;
	uploading: boolean;
	setUploading: (value: boolean) => void;
}

interface IPropsImportSearchGrid {
	gridData: IGridData;
	setGridData: (form: IGridData) => void;
	formFilters: SupplierInventoryImportRequest | null;
	setFormFilters: (formFilters: SupplierInventoryImportRequest | null) => void;
	getGridData: (formFilters: SupplierInventoryImportRequest) => void;
	reloadGridData: (formFilters: SupplierInventoryImportRequest) => void;
	hasShowMore: boolean;
	setHasShowMore: (hasShowMore: boolean) => void;
	pageIndex: number;
	setPageIndex: (index: number) => void;
	isLoadingInfiniteScroll: boolean;
	gridDataEmpty: boolean;
}

export function getRequestGrid(formInputs: ISearchImportHistoryForm) {
	const requestForm: SupplierInventoryImportRequest = {
		guidCountry: String(formInputs.country?.key),
		guidSupplier: String(formInputs.supplier?.key),
		pageIndex: PaginationEnum.PageIndexIntial,
		pageSize: PaginationEnum.PageSize30,
		idCompanyType: !isNullUndefined(formInputs.companyType?.key) ? String(formInputs.companyType?.key) : null,
		guidCompany: formInputs.company?.map((item) => String(item.key)),
		importType: formInputs.inventoryFileType?.key as InventoryFileTypeEnum,
	};

	return removeEmptyValues(requestForm);
}
const ID_TAB_IMPORT_HISTORY = 0;
const SupplierSearchGrid = ({
	gridDataEmpty,
	gridData,
	formFilters,
	setFormFilters,
	getGridData,
	reloadGridData,
	hasShowMore,
	pageIndex,
	setPageIndex,
	isLoadingInfiniteScroll,
}: IPropsImportSearchGrid) => {
	const rowHeaders = [
		getTranslateByKey("information.filename"),
		getTranslateByKey("information.type"),
		getTranslateByKey("information.supplier"),
		getTranslateByKey("information.concatcompany"),
		`${getTranslateByKey("information.userName")} - ${getTranslateByKey("information.dateTime")}`,
		getTranslateByKey("information.status"),
		getTranslateByKey("information.actions"),
	];

	interface LoadingMap {
		[key: string]: boolean;
	}

	const [isLoadingCancelMap, setIsLoadingCancelMap] = useState<LoadingMap>({});

	function onLoadSearchGrid() {
		const index = pageIndex + PaginationEnum.PageIndexIntial;
		setPageIndex(index);

		const formFiltersOnLoadSearchGrid = formFilters;
		if (formFiltersOnLoadSearchGrid) {
			formFiltersOnLoadSearchGrid.pageIndex = index;

			setFormFilters(formFiltersOnLoadSearchGrid);
			getGridData(formFiltersOnLoadSearchGrid);
		}
	}

	function reloadSearchGrid() {
		const formFiltersOnLoadSearchGrid = formFilters;
		if (formFiltersOnLoadSearchGrid) {
			formFiltersOnLoadSearchGrid.pageIndex = PaginationEnum.PageIndexIntial;

			setFormFilters(formFiltersOnLoadSearchGrid);
			reloadGridData(formFiltersOnLoadSearchGrid);
		}
	}

	function handleErrorLog(fileName: string) {
		const requestForm: LogErrorImportRequest = {
			fileNameGuidSupplierInventoryImport: fileName,
		};

		supplierInventoryImportApi.getLogError(requestForm).then((response) => {
			downloadXML(response.data.result, fileName);
		});
	}

	function handleDownloadImport(fileName: string, supplierInventoryImportGuid: string) {
		supplierInventoryImportApi.downloadImportFile(supplierInventoryImportGuid).then((response) => {
			if (response.data.result) {
				const base64File = response.data.result;
				downloadFile(base64File, fileName);
			}
		});
	}

	function handleCancelItem(e: React.MouseEvent<HTMLButtonElement, MouseEvent>, supplierInventoryImportGuid: string) {
		e.preventDefault();
		e.stopPropagation();
		setIsLoadingCancelMap({
			...isLoadingCancelMap,
			[supplierInventoryImportGuid]: true,
		});

		supplierInventoryImportApi
			.cancelImport(supplierInventoryImportGuid)
			.then(() => {
				toast.success(getTranslateByKey("information.importCancelledSuccessfully"));
				reloadSearchGrid();
			})
			.finally(() => {
				setIsLoadingCancelMap({
					...isLoadingCancelMap,
					[supplierInventoryImportGuid]: false,
				});
			});
	}

	const titleGrid = getDefaultMessageResultsFound(gridData.data.length, gridData.totalItems);

	if (gridData.isLoading) return <LoadingComponent />;
	if ((gridData.data.length === 0 && formFilters !== null) || gridDataEmpty)
		return <ResultNotFoundComponent styles={{ marginTop: 10 }} />;
	if (gridData.data.length === 0 && !gridData.isLoading) return null;
	const generateValueFileType = (id: InventoryFileTypeEnum) =>
		getOptionsInventoryFileType().find((item) => item.key === id);
	return (
		<BoxGrid
			title={titleGrid}
			centerLastColumn={true}
			rowHeaders={rowHeaders}
			infiniteScrollConfig={{
				dataLength: gridData.data.length,
				fetchData: () => onLoadSearchGrid(),
				hasMore: hasShowMore,
				isLoading: isLoadingInfiniteScroll,
			}}
		>
			{gridData.data.map((imports: SupplierInventoryImportDataResponse) => (
				<KOGTableRow key={imports.supplierInventoryImportGuid} $notClickable={true}>
					<TableCell width="20%" title={imports.filename}>
						<S.ColumnLink
							onClick={() => handleDownloadImport(imports.filename, imports.supplierInventoryImportGuid)}
							id="id-importHistory-downloadImport-button"
						>
							{imports.filename}
						</S.ColumnLink>
					</TableCell>
					<TableCell width="25%" title={generateValueFileType(imports.importType)?.value}>
						<S.ColumnText>{generateValueFileType(imports.importType)?.value}</S.ColumnText>
					</TableCell>
					<TableCell width="20%" title={imports.supplierName}>
						<S.ColumnText>{imports.supplierName}</S.ColumnText>
					</TableCell>
					<TableCell width="20%" title={imports.companyConcat}>
						<S.ColumnText>{imports.companyConcat}</S.ColumnText>
					</TableCell>
					<TableCell width="25%" title={`${imports.username} - ${imports.importTime}`}>
						<S.ColumnText>
							{imports.username} - {imports.importTime}
						</S.ColumnText>
					</TableCell>
					<TableCell width="10%">
						<StatusImportHistoryComponent status={imports?.status} />
					</TableCell>
					<TableCell style={{ textAlign: "center" }}>
						{imports.status === StatusSupplierInventoryImportEnum.Scheduled && (
							<IconButton
								id={`id-importHistory-icon-cancel-${imports.supplierInventoryImportGuid}`}
								title={getTranslateByKey("information.cancel")}
								onClick={(e) => handleCancelItem(e, imports.supplierInventoryImportGuid)}
							>
								{isLoadingCancelMap[imports.supplierInventoryImportGuid] ? <SpinnerLoading /> : <CloseIcon />}
							</IconButton>
						)}

						{(imports.status === StatusSupplierInventoryImportEnum.Error ||
							imports.status === StatusSupplierInventoryImportEnum.Partial) && (
							<>
								{imports.logSupplierInventoryPartsFileName !== undefined && (
									<S.ErrorLogButton
										onClick={() => handleErrorLog(imports.logSupplierInventoryPartsFileName)}
										id="id-importHistory-errorLogParts-button"
									>
										<SettingsIcon />
										{getTranslateByKey("information.errorLog")}
									</S.ErrorLogButton>
								)}
								{imports.logSupplierInventoryVehicleFileName !== undefined && (
									<S.ErrorLogButton
										onClick={() => handleErrorLog(imports.logSupplierInventoryVehicleFileName)}
										id="id-importHistory-errorLogVehicles-button"
									>
										<DirectionsCarIcon />
										{getTranslateByKey("information.errorLog")}
									</S.ErrorLogButton>
								)}
							</>
						)}
					</TableCell>
				</KOGTableRow>
			))}
		</BoxGrid>
	);
};

function ImportHistoryTab({
	showFilters,
	setShowFilters,
	openModalImportInventory,
	closeModalImportInventory,
	filesModalImportInventory,
	setFilesModalImportInventory,
	setTabCurrent,
	gridData,
	setGridData,
	hasShowMore,
	setHasShowMore,
	searchGridHistory,
	gridDataEmpty,
	setGridDataEmpty,
	exporting,
	setExporting,
	uploading,
	setUploading,
}: IPropsImportHistoryTab) {
	const dispatch = useDispatch();

	// State & reducers
	const countryReducer = useCountryReducer();
	const companyTypeReducer = useCompanyTypeReducer();
	const companyReducer = useCompanyReducer();

	const { supplierInventoryImportStatus: supplierInventoryImportStatusReducer } =
		useSupplierInventoryImportStatusReducer();
	const supplierReducer = useSupplierReducer();
	const parameterRangeDays = useParameterByTypeScreenReducer(ParameterTypeEnum.DefaultSearchImportsInterval);
	const optionDefaultCountryDrop = getDefaultOptionDrop(countryReducer.countriesUser.data);

	const optionDefaultSupplierDrop = getDefaultOptionDrop(supplierReducer.suppliers.data);

	const optionDefaultCompanyTypeDrop = getDefaultOptionDrop(companyTypeReducer.companyType.data);

	const INITIAL_FORM_STATE: ISearchImportHistoryForm = {
		tab: ID_TAB_IMPORT_HISTORY,
		country: optionDefaultCountryDrop,
		supplier: optionDefaultSupplierDrop,
		filename: "",
		supplierInventoryImportStatus: null,
		tradeName: "",
		inventoryFileType: null as KeyValue | null,
		startDate: initalDateForm(parameterRangeDays),
		finalDate: initalDateForm(),
		companyType: null as KeyValue | null,
		company: [] as KeyValue[] | null,
	};
	const {
		control,
		customHandleSubmit,
		setValue,
		queryParamsValues,
		formState: { errors },
		reset,
		watch,
		onSubmitByQueryParams,
		getValues,
	} = useFormQueryParams<ISearchImportHistoryForm>({
		mode: "onChange",
		defaultValues: INITIAL_FORM_STATE,
		autoSearchByUrl: false,
		validQueryParams: {
			tab: INITIAL_FORM_STATE.tab,
		},
		mapDefaultValues: {
			country: countryReducer.countriesUser,
			supplier: supplierReducer.suppliers,
			supplierInventoryImportStatus: supplierInventoryImportStatusReducer,
			company: companyReducer.company,
			inventoryFileType: mountReducerWithData(getOptionsInventoryFileType()),
			companyType: companyTypeReducer.companyType,
		},
		onSubmit: onSubmit,
	});
	const INITIAL_GRID_STATE: IGridData = {
		totalItems: 0,
		isLoading: false,
		data: [],
	};
	const [formFilters, setFormFilters] = useState<SupplierInventoryImportRequest | null>(null);
	const [pageIndex, setPageIndex] = useState<number>(PaginationEnum.PageIndexIntial);
	const [isLoadingInfiniteScroll, setIsLoadingInfiniteScroll] = useState<boolean>(false);

	const isDisabledSupplierDrop = () => supplierReducer.suppliers.data === null || getValues().country === null;
	const watcherStartDate = watch("startDate");
	const watcherFinalDate = watch("finalDate");

	const isDisabledCompanyTypeDrop = () => companyTypeReducer.companyType.data === null;

	const isDisabledCompanyDrop = () => getValues().companyType === null;

	// UseEffect's
	// Initial load
	useEffect(() => {
		dispatch(getCountriesUser());
		dispatch(getSupplierInventoryImportStatus());
		dispatch(getCompanyType());

		return () => {
			dispatch(resetReducerSuppliers());
		};
	}, []);

	useEffect(() => {
		// Call API's related by country default
		if (optionDefaultCountryDrop) {
			callSupplierApiDomain(optionDefaultCountryDrop);
		}
	}, [optionDefaultCountryDrop?.key]);

	function handleClear() {
		reset(INITIAL_FORM_STATE);
		setValue("supplierInventoryImportStatus", null);
		const { firstDateResult, secondDateResult } = onLoadDateRangePicker(parameterRangeDays);
		setValue("startDate", firstDateResult);
		setValue("finalDate", secondDateResult);
		setGridData(INITIAL_GRID_STATE);
		setFormFilters(null);
		setPageIndex(PaginationEnum.PageIndexIntial);
		setHasShowMore(false);
		setIsLoadingInfiniteScroll(false);

		if (optionDefaultCountryDrop) {
			callSupplierApiDomain(optionDefaultCountryDrop);
		} else {
			dispatch(resetReducerSuppliers());
		}

		if (companyTypeReducer.companyType.data !== null) {
			const keyCompanyType = String(CompanyTypeEnum.Insurer);
			const valueCompanyType = String(
				companyTypeReducer.companyType.data?.find((x) => x.key === keyCompanyType)?.value,
			);
			setValue("companyType", {
				key: keyCompanyType,
				value: valueCompanyType,
			});
		}
		setValue("companyType", optionDefaultCompanyTypeDrop);
		if (optionDefaultCountryDrop !== null && optionDefaultCompanyTypeDrop !== null) {
			callCompanyApiDomain(optionDefaultCountryDrop, optionDefaultCompanyTypeDrop);
		}
	}

	const onlyShowCompanyTypes = [CompanyTypeEnum.Insurer, CompanyTypeEnum.BodyShop];
	const optionsFilteredCompanyType = isNullUndefined(companyTypeReducer.companyType.data)
		? null
		: companyTypeReducer.companyType.data
				.filter((item) => onlyShowCompanyTypes.includes(Number(item.key)))
				.sort((a, b) => a.value.localeCompare(b.value));

	function callCompanyApiDomain(countrySelected: KeyValue | null, companyTypeSelected: KeyValue | null) {
		if (!isValueQueryParams(countrySelected) || !isValueQueryParams(companyTypeSelected)) {
			setValue("company", null);
		}
		dispatch(resetReducerCompany());

		if (countrySelected !== null) {
			const request: CompanyFilterRequest = {
				guidCountry: String(countrySelected.key),
				type: HeadQuarterBranchFilterEnum.All,
			};
			if (companyTypeSelected) {
				request.idCompanyType = String(companyTypeSelected.key);
				dispatch(getCompany(request));
			}
		}
	}

	function callSupplierApiDomain(optionSelected: KeyValue | null) {
		// Clean fields & reducers
		setValue("supplier", null);
		dispatch(resetReducerSuppliers());

		if (optionSelected !== null) {
			const request: SupplierFilterRequest = {
				guidCountry: String(optionSelected.key),
				type: HeadQuarterBranchFilterEnum.All,
				idStatusRegister: StatusRegisterEnum.Active,
			};
			dispatch(getSuppliers(request));
		}
	}

	function onSubmit(formInputs: ISearchImportHistoryForm) {
		validateFormDate(formInputs.startDate, formInputs.finalDate, parameterRangeDays);
		setGridDataEmpty(false);
		setPageIndex(PaginationEnum.PageIndexIntial);
		setGridData({
			isLoading: true,
			totalItems: 0,
			data: [],
		});
		const requestForm: SupplierInventoryImportRequest = {
			...getRequestGrid(formInputs),
			filename: formInputs.filename,
			startDate: formatDateToISOString(formInputs.startDate),
			finalDate: formatDateToISOString(watcherFinalDate),
			status: formInputs.supplierInventoryImportStatus?.key
				? StatusSupplierInventoryImportEnum[formInputs.supplierInventoryImportStatus?.key]
				: null,
		};

		setFormFilters(requestForm);
		const requestFormatted = removeEmptyValues(requestForm);

		supplierInventoryImportApi.getSearchGrid(requestFormatted).then((response) => {
			setGridData({
				isLoading: false,
				totalItems: response.data.totalNumberOfRecords,
				data: response.data.results,
			});
			setHasShowMore(response.data.results.length < response.data.totalNumberOfRecords);
		});
		setShowFilters(false);
	}

	function onReloadGrid(request: SupplierInventoryImportRequest) {
		validateFormDate(request.startDate, request.finalDate, parameterRangeDays);
		setGridDataEmpty(false);
		setPageIndex(PaginationEnum.PageIndexIntial);
		setGridData({
			isLoading: true,
			totalItems: 0,
			data: [],
		});

		const requestFormatted = removeEmptyValues(request);

		supplierInventoryImportApi.getSearchGrid(requestFormatted).then((response) => {
			setGridData({
				isLoading: false,
				totalItems: response.data.totalNumberOfRecords,
				data: response.data.results,
			});
			setHasShowMore(response.data.results.length < response.data.totalNumberOfRecords);
		});
		setShowFilters(false);
	}

	function onLoadInfiniteScroll(request: SupplierInventoryImportRequest) {
		setIsLoadingInfiniteScroll(true);

		const requestFormatted = removeEmptyValues(request);
		supplierInventoryImportApi
			.getSearchGrid(requestFormatted)
			.then((response) => {
				let resultData: SupplierInventoryImportDataResponse[] = [];
				let resultTotalItems: number = 0;
				if (response.data && response.data.results && response.data.results.length > 0) {
					resultData = response.data.results;
					resultTotalItems = response.data.totalNumberOfRecords;
				}
				if (gridData.data.length > 0) {
					resultData = [...gridData.data, ...resultData];
				}
				setGridData({
					isLoading: false,
					totalItems: resultTotalItems,
					data: resultData,
				});

				// Disable show more
				if (resultTotalItems < PaginationEnum.PageSize30 || resultTotalItems === resultData.length) {
					setHasShowMore(false);
				}
			})
			.finally(() => setIsLoadingInfiniteScroll(false));
	}

	useEffect(() => {
		if (isNullUndefined(countryReducer.countriesUser.data)) return;
		const hasCountryDefault =
			countryReducer.countriesUser.data.length === 1 && !isNullUndefined(optionDefaultCountryDrop);
		const queryParamsValuesWithCountryDefault: ISearchImportHistoryForm = {
			...queryParamsValues,
			...(hasCountryDefault && { country: optionDefaultCountryDrop }),
		};
		onSubmitByQueryParams(queryParamsValuesWithCountryDefault);
	}, [JSON.stringify(queryParamsValues), JSON.stringify(countryReducer.countriesUser.data)]);

	return (
		<>
			{openModalImportInventory && (
				<ModalImportInvetory
					open={openModalImportInventory}
					closeModal={closeModalImportInventory}
					files={filesModalImportInventory}
					setFiles={setFilesModalImportInventory}
					setTabCurrent={setTabCurrent}
					onSearchGrid={(params) => {
						const paramsFormatted = {
							...params,
							startDate: watcherStartDate ? formatDateToISOString(watcherStartDate) : null,
							finalDate: watcherFinalDate ? formatDateToISOString(watcherFinalDate) : null,
						};
						searchGridHistory(paramsFormatted);
					}}
					exporting={exporting}
					setExporting={setExporting}
					uploading={uploading}
					setUploading={setUploading}
				/>
			)}
			<S.Container>
				<Box showBox={showFilters} title={getTranslateByKey("information.filters")}>
					<form onSubmit={customHandleSubmit} noValidate>
						<S.RowInputs>
							<KogAutoCompleteControlled
								required
								label={getTranslateByKey("information.country")}
								control={control}
								options={countryReducer.countriesUser.data}
								isLoading={countryReducer.countriesUser.isLoading}
								nameCustom="country"
								rulesCustom={{ required: true }}
								errorMessageCustom={
									errors.country?.type === "required" ? getTranslateByKey("information.countryRequired", true) : ""
								}
								hasErrorCustom={!!errors.country}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callSupplierApiDomain(optionSelected);
								}}
								autoHighlightCustom={!!optionDefaultCountryDrop}
								setValueCustom={setValue}
								disabled={optionDefaultCountryDrop !== null}
								id="id-importHistory-txt-country"
							/>
							<KogKeyboardDatePickerContainer
								idScreen="id-importHistory"
								nameStartDate="startDate"
								nameFinalDate="finalDate"
								parameterRangeDays={parameterRangeDays}
								control={control}
							/>
							<KogAutoCompleteControlled
								label={getTranslateByKey("information.supplier")}
								control={control}
								nameCustom="supplier"
								rulesCustom={{ required: false }}
								errorMessageCustom=""
								hasErrorCustom={false}
								options={supplierReducer.suppliers.data}
								isLoading={supplierReducer.suppliers.isLoading}
								onChangeCustom={() => {}}
								disabled={isDisabledSupplierDrop() || !!optionDefaultSupplierDrop}
								autoHighlightCustom={!!optionDefaultSupplierDrop}
								setValueCustom={setValue}
								id="id-importHistory-txt-supplier"
							/>
						</S.RowInputs>
						<S.RowInputs>
							<KogAutoCompleteControlled
								required
								id="id-searchUserGroup-select-companyType"
								label={getTranslateByKey("information.companyType")}
								control={control}
								options={optionsFilteredCompanyType}
								isLoading={companyTypeReducer.companyType.isLoading}
								nameCustom="companyType"
								rulesCustom={{ required: false }}
								errorMessageCustom={
									errors.companyType?.type === "required"
										? getTranslateByKey("information.companyTypeRequired", true)
										: ""
								}
								setValueCustom={setValue}
								hasErrorCustom={!!errors.companyType}
								disabled={isDisabledCompanyTypeDrop()}
								onChangeCustom={(optionSelected: KeyValue | null) => {
									callCompanyApiDomain(getValues().country, optionSelected);
								}}
							/>
							<KogInputAutoCompleteCheckControlled
								name="company"
								disableSelectAll
								control={control}
								options={companyReducer.company.data || []}
								disableVirtualization
								label={getTranslateByKey("information.company")}
								disabled={isDisabledCompanyDrop()}
								isLoading={companyReducer.company.isLoading}
								controllerProps={{ rules: { required: false } }}
								customInputProps={{
									required: false,
									id: "id-searchimport-select-company",
								}}
								onChangeCustom={(value, optionChanged, reason) => {
									switch (reason) {
										case "selectOption":
											break;
										case "removeOption":
											break;
										case "clear":
											break;
										default:
											break;
									}
								}}
							/>
							<KogInputTextControlledNew
								label={getTranslateByKey("information.filename")}
								name="filename"
								error={!!errors.filename}
								control={control}
								id="id-importHistory-txt-filename"
							/>
							<KogAutoCompleteControlled
								required
								label={getTranslateByKey("information.type")}
								control={control}
								options={getOptionsInventoryFileType()}
								isLoading={false}
								nameCustom="inventoryFileType"
								rulesCustom={{ required: false }}
								onChangeCustom={() => {}}
								setValueCustom={setValue}
								disabled={false}
								id="id-importHistory-select-file-type"
							/>
							<KogAutoCompleteControlled
								label={getTranslateByKey("information.status")}
								nameCustom="supplierInventoryImportStatus"
								errorMessageCustom=""
								control={control}
								setValueCustom={setValue}
								options={supplierInventoryImportStatusReducer.data}
								isLoading={supplierInventoryImportStatusReducer.isLoading}
								rulesCustom={{ required: false }}
								hasErrorCustom={false}
								onChangeCustom={() => {}}
								id="id-importHistory-txt-status"
							/>
						</S.RowInputs>
						<KOGAreaButtons>
							<SecondaryButton type="submit" id="id-importHistory-btn-search">
								{getTranslateByKey("information.search")}
							</SecondaryButton>
							<SecondaryButton onClick={handleClear} id="id-importHistory-btn-clear">
								{getTranslateByKey("information.clear")}
							</SecondaryButton>
						</KOGAreaButtons>
					</form>
				</Box>

				<SupplierSearchGrid
					isLoadingInfiniteScroll={isLoadingInfiniteScroll}
					pageIndex={pageIndex}
					setPageIndex={setPageIndex}
					hasShowMore={hasShowMore}
					setHasShowMore={setHasShowMore}
					gridData={gridData}
					setGridData={setGridData}
					gridDataEmpty={gridDataEmpty}
					formFilters={formFilters}
					setFormFilters={setFormFilters}
					getGridData={(request: SupplierInventoryImportRequest) => {
						onLoadInfiniteScroll(request);
					}}
					reloadGridData={(request: SupplierInventoryImportRequest) => {
						onReloadGrid(request);
					}}
				/>
			</S.Container>
		</>
	);
}

// export default ImportHistoryTab
export default withQueryparams(ImportHistoryTab, {
	customName: "importHistoryTab",
	validateQueryParams: {
		tab: ID_TAB_IMPORT_HISTORY,
	},
});
